import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import Grid from '@mui/material/Grid2'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tab from '@mui/material/Tab'
import Tabs from '@mui/material/Tabs'
import Typography from '@mui/material/Typography'
import { filter, transform } from 'lodash'
import * as React from 'react'
import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { BlockWrapper } from '../../../components/Wrapper/BlockWrapper'
import { useFilesStore } from '../../../store/storeFiles'
import { useRequestsStore } from '../../../store/storeRequests'
import { useSettingStore } from '../../../store/storeSetting'
import { useWrapperStore } from '../../../store/storeWrapper'
import GridIcon from './../../../assets/icons/GridIcon.svg'
import GripLinesIcon from './../../../assets/icons/GripLines.svg?react'
import { ContextSettingCard } from './components/ContextSettingCard'
import { Files } from './components/Files'

export const RequestSettingPage = ({ type }) => {
    const isRequestPage = type === 'request'
    const params = useParams()
    const navigate = useNavigate()
    const [value, setValue] = React.useState(0)
    const [viewFileList, setViewFileList] = React.useState('card')
    const [customModelValues, setCustomModelValues] = React.useState(undefined)
    const handleChange = (event: React.SyntheticEvent, newValue: number) => {
        setValue(newValue)
    }

    const handleChangeViewFileList = (event: React.SyntheticEvent, newValue: number) => {
        setViewFileList(newValue)
    }

    const { requestDetail, fetchRequestDetail } = useRequestsStore((state) => state)

    const { modelDetail } = useSettingStore((state) => state)
    const { fetchModelDetail, fetchProjectDetail, projectDetail } = useWrapperStore(
        (state) => state,
    )
    const { fetchFilesUser } = useFilesStore((state) => state)

    useEffect(() => {
        if (isRequestPage && !requestDetail) {
            fetchRequestDetail({ threadId: +params.requestId })
        }
    }, [])

    useEffect(() => {
        if (!isRequestPage && !projectDetail) {
            fetchProjectDetail({ workplaceId: params.projectId })
        }
    }, [])

    useEffect(() => {
        if (value === 1) {
            fetchFilesUser({
                prefix: '/' + (isRequestPage ? `${params.requestId}` : `${params.projectId}`) + '/',
            })
        }
    }, [value])

    useEffect(() => {
        if (requestDetail && !modelDetail) {
            fetchModelDetail(requestDetail.agent, requestDetail.assistant_id)
        }
    }, [requestDetail, modelDetail])

    useEffect(() => {
        if (requestDetail && modelDetail) {
            setCustomModelValues(
                transform(
                    modelDetail?.series?.params,
                    function (result, value, key) {
                        const params = requestDetail.params?.length
                            ? filter(requestDetail.params, { name: value.title })
                            : null

                        return (result[value.title] =
                            params && params[0] ? params[0].value : value?.default)
                    },
                    {},
                ),
            )
        }
    }, [requestDetail, modelDetail])

    return (
        <BlockWrapper>
            <Grid container sx={{ height: `calc(100dvh - ${110}px)`, width: '100%' }}>
                <Grid size={12}>
                    <Box sx={{ maxHeight: `calc(100dvh - ${120}px)`, overflow: 'auto' }}>
                        <Stack
                            direction="row"
                            sx={{
                                alignItems: 'center',
                                padding: '16px',
                                justifyContent: 'space-between',
                            }}>
                            <Stack direction="row" sx={{ alignItems: 'center' }}>
                                <IconButton
                                    sx={{
                                        '&:hover': { borderColor: '#F4F4F6' },
                                        background: ' #fff',
                                    }}
                                    variant="text"
                                    color="primary"
                                    onClick={() =>
                                        navigate(
                                            isRequestPage
                                                ? `/request/${params.requestId}`
                                                : `/project?workplaceId=${params.projectId}`,
                                        )
                                    }>
                                    <ArrowBackIcon />
                                </IconButton>

                                <Typography
                                    variant="h6"
                                    sx={{
                                        color: '#181B25',
                                    }}>
                                    Настройки {isRequestPage ? 'запроса' : 'проекта'}
                                </Typography>
                            </Stack>
                            {value === 1 && (
                                <Tabs
                                    value={viewFileList}
                                    onChange={handleChangeViewFileList}
                                    sx={{
                                        borderBottom: 'none',
                                        padding: 0,
                                        alignItems: 'center',
                                    }}>
                                    <Tab variant="secondary" value="card" icon={<GridIcon />} />
                                    <Tab
                                        variant="secondary"
                                        value="table"
                                        icon={<GripLinesIcon />}
                                        id="1"
                                        sx={{ p: 0 }}
                                    />
                                </Tabs>
                            )}
                        </Stack>
                        <Divider />

                        <Grid container spacing={2} m={2}>
                            <Grid size={12}>
                                <Tabs
                                    value={value}
                                    onChange={handleChange}
                                    sx={{ borderBottom: 'none', padding: 0 }}>
                                    <Tab id="0" label="Контекст" />
                                    <Tab label="Вложения контекста" id="1" />
                                </Tabs>
                            </Grid>

                            {value === 0 &&
                                (isRequestPage ? requestDetail && modelDetail : projectDetail) && (
                                    <Grid
                                        sx={{
                                            display: 'flex',
                                            width: '100%',
                                            maxWidth: '740px',
                                        }}>
                                        <ContextSettingCard isRequestPage={isRequestPage} />
                                    </Grid>
                                )}

                            {value === 1 && (
                                <Files
                                    viewFileList={viewFileList}
                                    isRequestPage={isRequestPage}
                                    isReadOnly={false}
                                />
                            )}
                        </Grid>
                    </Box>
                </Grid>
            </Grid>
        </BlockWrapper>
    )
}
